const color = {
  // neutral - 무채색
  white: "#FFFFFF",
  neutral_50: "#F9F9F9",
  neutral_100: "#EFEFEF",
  neutral_200: "#E0E0E0",
  neutral_300: "#B7B7B7",
  neutral_400: "#9C9C9C",
  neutral_500: "#737474",
  neutral_600: "#484848",
  neutral_700: "#393A3A",
  neutral_800: "#1A2723",
  black: "#000000",

  // green
  // green_100: "#F1FFF3",
  // green_500: "#5CC86D", // main
  // green_600: "#52B361",
  // green_700: "#2E6437",
  green_100: "#F1FFF3",
  green_300: "#5CC86D",
  green_400: "#52B361",
  green_500: "#25863F", // main
  green_600: "#2E6437",
  green_700: "#295931",

  // aquamarine
  aquamarine_100: "#EBF8F4",
  aquamarine_500: "#27826A",
  aquamarine_600: "#1B6753",
  // aquamarine_500: "#5CC8A3",
  // aquamarine_600: "#51AF8F",

  // red
  red_100: "#FFF6F5",
  red_200: "#FFE8E7",
  red_400: "#FF7271",
  red_500: "#FF4341",
  red_600: "#DF3B39",

  // orange
  orange_100: "#FDF6F2",
  orange_200: "#FFEEE4",
  orange_400: "#FF9960",
  orange_500: "#FF5B00",
  orange_600: "#DF6826",

  // yellow
  yellow_100: "#FFF9ED",
  yellow_500: "#FFD400",
  yellow_600: "#DFB462",

  // pastelRed
  pastelRed_200: "#FFDEDB",
  pastelRed_500: "#F35A58",
  pastelRed_600: "#D54F4D",

  // pastelGreen
  pastelGreen_500: "#14A97F",

  // pastelOrange
  pastelOrange_500: "#F56A00",
};

const statusColor = {
  MAIN: color.green_500,
  MAIN_HOVER: color.green_600,
  SECONDARY: color.aquamarine_500,
  DISABLED: color.neutral_200,
  CLOSE: color.neutral_400,
  CLOSE_HOVER: color.neutral_500,
  INPUT_DEFAULT: "#FAFAFA",
  INPUT_ACTIVE: "#F5FDFC",
  INPUT_ERROR: "#FFF2F2",
  PLACEHOLDER: "#BBBBBB",
  TOOLTIP: "#898989",
  TITLE: color.neutral_600,
  SCROLLBAR: "#C1C1C1",
};

const zindex = {
  arrowMarker: 1,    // 화살표 마커 (가장 아래)
  startMarker: 4,    // 시작 마커
  endMarker: 5,      // 종료 마커
  orangeMarker: 6,   // 차량 전복 외 이벤트 (위)
  redMarker: 7,      // 차량 전복 이벤트 (가장 위)
  overlayMap: 8,     // 오버레이 (최상위)
  controlListMd: 31, // 농기계 사고 관제 모바일버전 리스트
  scrollBtn: 50, // 농기계 사고 관제 모바일버전 화면 스크롤 버튼
  verticalNav: 70,
  tabBtn: 60,
  tabBtnMd: 70,
  arrowBtnMd: 70, // 농기계 사고 관제 모바일버전 리스트 토글 버튼
  customModal: 98,
  toastMsg: 10, // 최상위 유지 (사고 발생 메시지)
  accidentBlink: 10000, // 사고 알림 UI
};

const fontSize = {
  HEADER_1: "22px",
  BOTTOM_SHEET_1: "16px",
  FONT_1: "14px",
  FONT_2: "12px",
  FONT_3: "10px",
  CAPTION_1: "8px",
};

const fontWeight = {
  BOLD: `700`,
  SEMI_BOLD: `600`,
  NORMAL: `400`,
};

const basic = {
  BORDER_RADIUS: `5px`,
};

/**
 * sm: 0px ~ 450px
 * md: 451px ~ 768px
 * lg: 769px~ 1280px
 * xl: 1281px ~
 */
const screen = {
  // number
  sm: 450,
  md: 768,
  lg: 1280,
};

const theme = {
  color,
  statusColor,
  zindex,
  screen,
  fontSize,
  fontWeight,
  basic,
};

export default theme;
